import * as R from 'ramda'
import * as ReactRedux from 'react-redux'
import * as ReactRouter from 'react-router-dom'
import React from 'react'

import * as Session from './session'
import { RegistrationDrawer } from './registration-drawer'

export function Registration() {
  const location = ReactRouter.useLocation()
  const history = ReactRouter.useHistory()
  const authenticated = ReactRedux.useSelector(state =>
    Session.isAuthenticated(state.session)
  )

  // Redirect users from old registration links to new one
  React.useEffect(() => {
    if (R.equals(location.hash, '#register')) {
      history.push({
        pathname: location.pathname,
        search: '?register=me',
      })
    }
  }, [location.hash])

  if (authenticated) {
    return null
  }

  return <RegistrationDrawer />
}
